import * as React from 'react'
import { Redirect } from 'react-router'
import { IActiveTripResponseV2, IRiderObject, ITripEdit } from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import Modal from './../../ui/Modal'
import * as moment from 'moment'
import CharacterCounter from '../../ui/CharacterCounter'
import Select from 'react-select'
import TimeOption from '../../icons/ui/TimeOption'
import { Datepicker } from '@mobiscroll/react'

const delimeter = '\u2000'
const seperator = ';'

export interface IFormValues {
  formError?: string
  note?: string
  birthDate?: string
  defaultNotificationPreference: ISelectOption
  email: string
  firstName: string
  lastName: string
  notificationPreference: string
  phone: string
  username: string
  externalId?: string
  internalNote?: string
}

interface ISelectOption {
  label: string
  value: string
}
export interface IEditTripModalProps {
  currentTrip: IActiveTripResponseV2
  startMileage: string
  history: any
  match: any
  riderName: string
  riders: { [key: number]: IRiderObject }
  note: string
  scheduledPickupTime?: string
  scheduledDropoffTime?: string
  leaveAtDateTime?: string
  arriveByDateTime?: string
  enableOtherFields: boolean
  duration: number
  fetchRiders: () => Promise<any>
  updateTripNotes: (notes: string) => Promise<any>
  setScheduledTime: (time: string, type: string) => Promise<any>
  saveData: (params: ITripEdit) => Promise<any>
  createTrip: (riderId: string) => void
  cloneTrip: (trip: IActiveTripResponseV2) => void
  cancelTrip: () => void
}

interface IEditTripModalState {
  selectedOption: { label: string; value: string }
  dropDownTags: any
  isSubmitting: boolean
  error: string
  isModalOpen: boolean
  redirect: boolean
  scheduledPickupTime: string | undefined
  scheduledDropoffTime: string | undefined
  leaveAtDateTime: string | undefined
  arriveByDateTime: string | undefined
  timeDelta: number
  notes: string | undefined
  prevScheduledPickupTime: string | undefined
  prevScheduledDropoffTime: string | undefined
  prevLeaveAtDateTime: string | undefined
  prevArriveByDateTime: string | undefined
  prevNotes: string | undefined
  currentSharedNotes: string | undefined
  numOfChar: number
}

const styles = {
  control: (provided: any, state: any) => {
    return {
      cursor: 'pointer',
      display: 'flex',
      minHeight: '38px'
    }
  },
  singleValue: (provided: any, state: any) => ({
    ...provided,
    color: '#137CBD'
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    color: '#137CBD'
  }),
  indicatorSeparator: (provided: any, state: any) => ({
    width: 0
  })
}
const options = [
  { label: 'Pickup time', value: 'pickup' },
  { label: 'Dropoff time', value: 'dropoff' },
  { label: 'Leave-at', value: 'leave-at' },
  { label: 'Arrive-by', value: 'arrive-by' }
]

const dropDownTags = [
  { label: '\u{1F91D}Hand-to-Hand', value: `\u{1F91D}Hand-to-Hand` },
  { label: '\u{1F9AE}Service-Animal', value: `\u{1F9AE}Service-Animal` },
  { label: '\u{1F9D1}\u{200D}\u{1F9AF}Blind-Person', value: `\u{1F9D1}\u{200D}\u{1F9AF}Blind-Person` },
  { label: '\u{1F9BB}Hearing-Impaired', value: '\u{1F9BB}Hearing-Impaired' },
  { label: '\u{1F4DE}Call(upon-arrival)', value: '\u{1F4DE}Call(upon-arrival)' },
  { label: '\u{1F9CF}\u{1F919}Cannot-Hear', value: '\u{1F9CF}\u{1F919}Cannot-hear' },
  { label: '\u{1F697}\u{1F9BD}Putting-Walker-in-trunk', value: '\u{1F697}\u{1F9BD}Putting-Walker-in-trunk' },
  { label: '\u{1F697}\u{1F6E3}Car-close-to-curb', value: '\u{1F697}\u{1F6E3}Car-close-to-curb' },
  { label: '\u{1F697}Car-by-curb-cut/no-curb', value: '\u{1F697}Car-by-curb-cut/no-curb' }
]
const CHARACTER_LIMIT = 250
class EditTripModal extends React.Component<IEditTripModalProps, IEditTripModalState> {
  constructor(props: any) {
    super(props)
    this.state = {
      selectedOption: options[0],
      dropDownTags: null,
      isSubmitting: false,
      error: '',
      isModalOpen: true,
      redirect: false,
      scheduledPickupTime: this.props.currentTrip.scheduledPickupTime,
      scheduledDropoffTime: this.props.currentTrip.scheduledDropoffTime,
      leaveAtDateTime: this.props.currentTrip.leaveAtDateTime,
      arriveByDateTime: this.props.currentTrip.arriveByDateTime,
      prevLeaveAtDateTime: this.props.currentTrip.leaveAtDateTime,
      prevArriveByDateTime: this.props.currentTrip.arriveByDateTime,
      timeDelta: 0,
      notes: this.props.currentTrip.notes,
      prevScheduledPickupTime: this.props.currentTrip.scheduledPickupTime,
      prevScheduledDropoffTime: undefined,
      prevNotes: this.props.currentTrip.notes || '',
      currentSharedNotes: undefined,
      numOfChar: this.props.currentTrip.notes ? CHARACTER_LIMIT - this.props.currentTrip.notes.length : CHARACTER_LIMIT
    }
    this.onChangeNotes = this.onChangeNotes.bind(this)
    this.setTag = this.setTag.bind(this)
    this.getTimeDelta = this.getTimeDelta.bind(this)
    this.handleCancelClick = this.handleCancelClick.bind(this)
    this.selectTimeDropOff = this.selectTimeDropOff.bind(this)
    this.selectTimePickUp = this.selectTimePickUp.bind(this)
    this.selectTimeLeaveAt = this.selectTimeLeaveAt.bind(this)
    this.selectTimeArriveBy = this.selectTimeArriveBy.bind(this)
    this.saveDetails = this.saveDetails.bind(this)
    this.onChangeNotes = this.onChangeNotes.bind(this)
  }
  public componentDidMount() {
    this.props.fetchRiders()
    this.setState({
      currentSharedNotes:
        this.state.notes !== undefined && this.state.notes !== null && this.state.notes.includes(seperator)
          ? this.state.notes.split(seperator)[0]
          : '',
      timeDelta: this.getTimeDelta()
    })
  }

  public componentDidUpdate(prevProps: any, prevState: IEditTripModalState) {
    if (prevState.notes !== this.state.notes && this.state.notes) {
      this.setState({
        numOfChar: CHARACTER_LIMIT - this.state.notes.length
      })
    }
  }
  public render() {
    const { currentTrip, enableOtherFields, cloneTrip, cancelTrip, createTrip } = this.props
    const riders = Object.values(this.props.riders)

    const saveText = this.state.isSubmitting ? 'Saving...' : UIMessages.common.saveDetails

    if (this.state.redirect === true || this.state.isModalOpen === false) {
      return <Redirect to={`/trips/${this.props.currentTrip.id}`} />
    }

    const nowSelected = this.state.selectedOption.value === 'now'
    const selectStyles = nowSelected ? { width: '24%' } : { width: '55%' }

    const matchingRider = riders.find(rider => {
      return rider.id === currentTrip.rider.riderId
    })

    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-3 p2'>
            <span className='ModalAddTitle weight-500 font-grey2 ml2 mr2 uppercase h4'>
              {UIMessages.common.editDetails}
              {'\n'}
            </span>

            <div
              style={{
                pointerEvents: this.state.isSubmitting ? 'none' : 'auto',
                opacity: this.state.isSubmitting ? 0.4 : 1.0
              }}
              className='ml2 mr2 mt1'
            >
              <br />
              {enableOtherFields && <span className='ModalAddTitle weight-500 font-grey2 uppercase h4'>Time</span>}
              {enableOtherFields && (
                <div className='flex items-center'>
                  <TimeOption className='' />
                  <div className='' style={selectStyles}>
                    <Select
                      styles={styles}
                      value={this.state.selectedOption}
                      options={options}
                      isSearchable={false}
                      onChange={this.selectTimeOption}
                    />
                  </div>
                  <div>
                    {this.state.selectedOption.value === 'pickup' && (
                      <Datepicker
                        controls={['calendar', 'time']}
                        dateFormat='MM/DD/YYYY'
                        defaultValue={moment(currentTrip.scheduledPickupTime)}
                        inputProps={{
                          className: 'border-none p1',
                          style: {
                            fontSize: '16px'
                          }
                        }}
                        timeFormat='h:mm A'
                        onChange={({ value }) => this.selectTimePickUp(value)}
                      />
                    )}
                    {this.state.selectedOption.value === 'dropoff' && (
                      <Datepicker
                        controls={['calendar', 'time']}
                        dateFormat='MM/DD/YYYY'
                        defaultValue={moment(currentTrip.scheduledDropoffTime)}
                        inputProps={{
                          className: 'border-none p1',
                          style: {
                            fontSize: '16px'
                          }
                        }}
                        min={moment(currentTrip.scheduledPickupTime)}
                        timeFormat='h:mm A'
                        onChange={({ value }) => this.selectTimeDropOff(value)}
                      />
                    )}
                    {this.state.selectedOption.value === 'leave-at' && (
                      <Datepicker
                        controls={['calendar', 'time']}
                        dateFormat='MM/DD/YYYY'
                        defaultValue={moment(
                          currentTrip.leaveAtDateTime ? currentTrip.leaveAtDateTime : currentTrip.scheduledPickupTime
                        )}
                        inputProps={{
                          className: 'border-none p1',
                          style: {
                            fontSize: '16px'
                          }
                        }}
                        min={moment(
                          currentTrip.leaveAtDateTime ? currentTrip.leaveAtDateTime : currentTrip.scheduledPickupTime
                        )}
                        timeFormat='h:mm A'
                        onChange={({ value }) => this.selectTimeLeaveAt(value)}
                      />
                    )}
                    {this.state.selectedOption.value === 'arrive-by' && (
                      <Datepicker
                        controls={['calendar', 'time']}
                        dateFormat='MM/DD/YYYY'
                        defaultValue={moment(
                          currentTrip.arriveByDateTime ? currentTrip.arriveByDateTime : currentTrip.scheduledDropoffTime
                        )}
                        inputProps={{
                          className: 'border-none p1',
                          style: {
                            fontSize: '16px'
                          }
                        }}
                        min={moment(
                          currentTrip.arriveByDateTime ? currentTrip.arriveByDateTime : currentTrip.scheduledDropoffTime
                        )}
                        timeFormat='h:mm A'
                        onChange={({ value }) => this.selectTimeArriveBy(value)}
                      />
                    )}
                  </div>
                </div>
              )}
              <br />
              {enableOtherFields && (
                <div className='flex flex-row'>
                  <div style={{ flex: 1 }} className='mt1'>
                    <label className='font-small bold font-grey3'>{UIMessages.common.riderProfileNote}</label>
                    <Select
                      classNamePrefix='select-control'
                      options={dropDownTags}
                      onChange={this.setTag}
                      value={dropDownTags.filter(
                        option =>
                          this.state.currentSharedNotes !== undefined &&
                          this.state.currentSharedNotes.includes(option.value)
                      )}
                      isMulti={true}
                      isClearable={true}
                    />
                  </div>
                </div>
              )}

              <div className='mb1 mt1'>
                <textarea
                  rows={6}
                  defaultValue={this.state.notes}
                  name='notes'
                  placeholder='Trip Notes'
                  onChange={this.onChangeNotes}
                  value={this.state.notes}
                  maxLength={CHARACTER_LIMIT}
                />
                <CharacterCounter numOfChar={this.state.numOfChar} />
              </div>
            </div>
            {!matchingRider && enableOtherFields && (
              <button
                className='SubmitButton btn bg-green rounded font-white weight-300'
                onClick={() => {
                  cloneTrip(currentTrip)
                  cancelTrip()
                  createTrip(currentTrip.rider.riderId)
                }}
              >
                Copy and CANCEL this trip
              </button>
            )}
            <div className='flex items-center justify-end mt3'>
              <button
                type='button'
                onClick={this.handleCancelClick}
                disabled={this.state.isSubmitting}
                className='CancelButton btn bg-white rounded font-light-grey mr2'
              >
                {UIMessages.common.cancel}
              </button>
              <button
                type='button'
                onClick={() => {
                  this.saveDetails()
                }}
                disabled={this.state.isSubmitting}
                className='SubmitButton btn bg-green rounded font-white weight-300'
              >
                {saveText}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private onChangeNotes = (e: any) => {
    this.setState({
      notes: `${e.target.value}`,
      prevNotes: this.props.currentTrip.notes
    })
  }
  private async saveDetails() {
    const {
      prevScheduledPickupTime,
      prevScheduledDropoffTime,
      prevLeaveAtDateTime,
      prevArriveByDateTime,
      prevNotes,
      currentSharedNotes
    } = this.state

    // Get the customize notes after the first semicolon(;). Succeeding semicolon is accepted as part of the message/notes
    let newNotes = ''
    if (this.state.notes !== undefined && this.state.notes.includes(seperator)) {
      const arrayNotes = this.state.notes.split(seperator)

      newNotes = ';' + arrayNotes[1]
      for (let i = 2; i < arrayNotes.length; i++) {
        newNotes += seperator + arrayNotes[i]
      }

      // check if the user manually changed the option tags in the notes box.
      // Then inform the user and update the option tags based on shared notes current selection
      if (this.state.notes !== undefined && currentSharedNotes !== this.state.notes.split(seperator)[0].trim()) {
        alert('Unable to update notes. Please do not include a "SEMICOLON".')
        return
      }

      const params: ITripEdit = {
        scheduledPickupTime: this.state.scheduledPickupTime,
        scheduledDropoffTime: this.state.scheduledDropoffTime,
        leaveAtDateTime: this.state.leaveAtDateTime,
        arriveByDateTime: this.state.arriveByDateTime,
        notes: currentSharedNotes + newNotes,
        prevScheduledPickupTime,
        prevScheduledDropoffTime,
        prevLeaveAtDateTime,
        prevArriveByDateTime,
        prevNotes,
        tripAction: 'EDIT_TRIP_DETAILS' // Specify trip actions to be use as reference when to send a push notification for trip notes
      }

      await this.props.saveData(params)
      this.setState({
        redirect: true,
        scheduledPickupTime: '',
        scheduledDropoffTime: '',
        currentSharedNotes: '',
        notes: ''
      })
    } else {
      // no semicolon in the notes, add before the message
      newNotes += ';' + this.state.notes

      // clear the currentSharedNotes
      this.setState({
        currentSharedNotes: ''
      })
      const params: ITripEdit = {
        scheduledPickupTime: this.state.scheduledPickupTime,
        scheduledDropoffTime: this.state.scheduledDropoffTime,
        notes: newNotes,
        prevScheduledPickupTime,
        prevScheduledDropoffTime,
        prevNotes,
        tripAction: 'EDIT_TRIP_DETAILS' // Specify trip actions to be use as reference when to send a push notification for trip notes
      }

      await this.props.saveData(params)
      this.setState({
        redirect: true,
        scheduledPickupTime: '',
        scheduledDropoffTime: '',
        currentSharedNotes: '',
        notes: ''
      })
    }
  }

  private selectTimeOption = (value: any) => {
    const { currentTrip } = this.props
    this.setState({ selectedOption: value })
    let currentTime = moment()

    if (value === 'pickup') {
      currentTime = moment(currentTrip.scheduledPickupTime)
      this.setState({
        scheduledPickupTime: `${moment(currentTrip.scheduledPickupTime)}`
      })
    } else if (value === 'dropoff') {
      currentTime = moment(currentTrip.scheduledDropoffTime)
      this.setState({
        scheduledDropoffTime: `${moment(currentTrip.scheduledDropoffTime)}`
      })
    } else if (value === 'leave-at') {
      currentTime = currentTrip.leaveAtDateTime
        ? moment(currentTrip.leaveAtDateTime)
        : moment(currentTrip.scheduledPickupTime)
      this.setState({
        leaveAtDateTime: currentTime.toISOString()
      })
    } else if (value === 'arrive-by') {
      currentTime = currentTrip.arriveByDateTime
        ? moment(currentTrip.arriveByDateTime)
        : moment(currentTrip.scheduledDropoffTime)
      this.setState({
        arriveByDateTime: currentTime.toISOString()
      })
    }

    this.props.setScheduledTime(currentTime.toISOString(), value.value)
  }

  private selectTimePickUp = (value: any) => {
    //calculate the seconds
    const timeDiff = moment(value).unix() - moment().unix()

    //Set the current pickup time value
    const pickup = moment(value)
    const scheduledPickupTime = pickup.toISOString()
    const scheduledDropoffTime = pickup.add(this.state.timeDelta, 'milliseconds').toISOString()
    this.setState({
      scheduledPickupTime,
      scheduledDropoffTime,
      prevScheduledPickupTime: this.props.currentTrip.scheduledPickupTime
    })
    //Set the current pickup time value

    if (timeDiff >= 0) {
      this.props.setScheduledTime(value, this.state.selectedOption.value)
    } else {
      this.props.setScheduledTime(moment().toISOString(), this.state.selectedOption.value)
    }
  }

  private selectTimeDropOff = (value: any) => {
    //calculate the seconds
    const timeDiff = moment(value).unix() - moment().unix()
    const dropoff = moment(value)
    const scheduledDropoffTime = dropoff.toISOString()
    const scheduledPickupTime = dropoff.subtract(this.state.timeDelta, 'milliseconds').toISOString()

    //Set the current dropoff time value
    this.setState({
      scheduledPickupTime,
      scheduledDropoffTime,
      prevScheduledDropoffTime: this.props.currentTrip.scheduledDropoffTime
    })
    //Set the current dropoff time value

    if (value._isAMomentObject) {
      if (timeDiff >= 0) {
        this.props.setScheduledTime(value, this.state.selectedOption.value)
      } else {
        this.props.setScheduledTime(moment().toISOString(), this.state.selectedOption.value)
      }
    }
  }

  private selectTimeLeaveAt = (value: any) => {
    //calculate the seconds
    const timeDiff = moment(value).unix() - moment().unix()
    console.log(`Duration: ${this.props.duration}`)
    //Set the current pickup time value
    const leaveAt = moment(value)
    const scheduledPickupTime = leaveAt.toISOString()
    const scheduledDropoffTime = leaveAt
      .clone()
      .add(this.props.duration, 'seconds')
      .toISOString()
    this.setState({
      leaveAtDateTime: leaveAt.toISOString(),
      arriveByDateTime: scheduledDropoffTime,
      scheduledPickupTime,
      scheduledDropoffTime,
      prevScheduledPickupTime: this.props.currentTrip.scheduledPickupTime
    })
    //Set the current pickup time value

    if (timeDiff >= 0) {
      this.props.setScheduledTime(value, this.state.selectedOption.value)
    } else {
      this.props.setScheduledTime(moment().toISOString(), this.state.selectedOption.value)
    }
  }

  private selectTimeArriveBy = (value: any) => {
    //calculate the seconds
    const timeDiff = moment(value).unix() - moment().unix()
    console.log(`Duration: ${this.props.duration}`)

    //Set the current pickup time value
    const arriveBy = moment(value)
    const scheduledPickupTime = arriveBy
      .clone()
      .subtract(this.props.duration, 'seconds')
      .toISOString()
    const scheduledDropoffTime = arriveBy.toISOString() //arriveBy.add(this.state.timeDelta, 'milliseconds').toISOString()
    this.setState({
      scheduledPickupTime,
      scheduledDropoffTime,
      leaveAtDateTime: scheduledPickupTime,
      arriveByDateTime: scheduledDropoffTime,
      prevArriveByDateTime: this.props.currentTrip.arriveByDateTime
    })
    //Set the current pickup time value

    if (timeDiff >= 0) {
      this.props.setScheduledTime(value, this.state.selectedOption.value)
    } else {
      this.props.setScheduledTime(moment().toISOString(), this.state.selectedOption.value)
    }
  }

  private handleCancelClick = () => {
    this.setState({ isModalOpen: false })
  }
  private getTimeDelta = () => {
    const pickup = moment(this.props.currentTrip.scheduledPickupTime)
    const dropoff = moment(this.props.currentTrip.scheduledDropoffTime)
    const timeDiff = dropoff.diff(pickup)
    return timeDiff ? timeDiff : 0
  }

  private reduceString = (stringArr: ISelectOption[]): string => {
    const tagsArr: string[] = []
    let tagString = ''
    if (stringArr) {
      stringArr.map((item: ISelectOption) => {
        tagsArr.push(item.value)
      })
      tagString = tagsArr.join(delimeter)
    }

    return tagString
  }

  private setTag = (values: ISelectOption[]) => {
    // get the string values of options tags
    const tags = this.reduceString(values)
    let oldNotes = ''
    // get the current notes
    if (this.state.notes !== undefined && this.state.notes.includes(seperator)) {
      oldNotes = this.state.notes.split(seperator)[1]

      // update current shared notes and customize message
      this.setState({
        currentSharedNotes: tags,
        notes: tags + seperator + oldNotes
      })
    } else {
      // update current shared notes and customize message
      this.setState({
        currentSharedNotes: tags,
        notes: tags + seperator + this.state.notes
      })
    }
  }
}

export default EditTripModal



// WEBPACK FOOTER //
// ./src/components/trips/edit-details/EditTripModal.tsx